module.exports = __webpack_public_path__ + "static/media/goal-set.55362069.png";